const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/reports.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/reports')({
  preload: false,
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'REPORTS',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async () => window.location.replace(`${process.env.PUBLIC_DREAMHAUS_URL}/reports`),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});